
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Franz E., 81, verstorben am 13. April 2020</b>
    <br />
    <br />
    <i>Seine Frau sagt:</i>
    <br />
    <p>
  «Wir tragen noch immer eine gewisse Wut und Trauer in uns, weil man ihn viel
  zu früh aus dem Spital nach Hause entlassen hat. Drei Tage später war er noch
  viel kränker und musste notfallmässig ins Universitätsspital. Er wurde dort
  beatmet. Zu Hause hat er auch mich angesteckt. Ich lag also krank und isoliert
  im Bett – und die Familie erfuhr von den Ärzten täglich, wie mein Mann im
  Spital mit dem Virus kämpfte.
    </p>
    <p>
  Es war ein Wechselbad aus Hoffnung und Enttäuschung. Die Ärzte versuchten
  alles, doch dann sagten sie nach 19 Tagen Behandlung, sie könnten nichts mehr
  tun.
    </p>
    <p>
  Ich hatte eine halbe Stunde Zeit, um mich auf den Abschied vorzubereiten. Ich
  machte mir ein paar Notizen. Dann hat sich der Arzt telefonisch gemeldet. Er
  sagte, er schliesse die Tür, er sei alleine mit meinem Mann. Er halte jetzt
  den Hörer an sein Ohr. So könne ich mich nun verabschieden.
    </p>
    <p>
  Es war grauenhaft. Natürlich hat mein Mann nichts sagen können, er war im
  künstlichen Koma. Aber wenigstens habe ich das Gefühl, dass ich mich irgendwie
  von ihm verabschieden konnte.
    </p>
    <p>
  Zwei Monate lang bin ich nicht aus dem Haus. Ich hatte die Kraft nicht, ich
  wollte auch niemanden treffen, weil ich noch nicht darüber reden konnte.
    </p>
    <p>
  Aber ich habe sehr liebe Kinder, die viel mit mir telefonieren und einkaufen.
  Und Nachbarn stellten mir Suppe vor die Tür.
    </p>
    <p>
  Ich verstehe die Leute nicht, die sich gegen die Massnahmen wehren. Man muss
  sich doch schützen. Und die anderen auch. Es scheint, dass zuerst etwas in der
  Familie passieren muss, bis sie es kapieren. Aber dann ist es zu spät. Denn
  mit Corona geht es extrem schnell, dass jemand befallen wird oder stirbt.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;